<template>
  <div class="hello">
    <el-container>
      <el-aside width="136px" class="leftEvt">
        <img src="../assets/logo copy.png" alt="" class="img_one">
        <div class="div_one">
          <b @click="handleMenuClick('1')">Work</b>
          <span @click="handleMenuClick('2')">Interior</span>
          <span @click="handleMenuClick('3')">Exterior</span>
          <span @click="handleMenuClick('4')" >Animation</span>
          <span @click="handleMenuClick('5')" style=" color: #960a0a;">VR360</span>
          <b @click="handleMenuClick('6')">About</b>
          <b @click="handleMenuClick('7')">Contact</b>

          <div style="display: flex;flex-direction: column;align-items: center;">
            <a href="https://www.behance.net/vrvimiu"><img src="../assets/Behance.png" alt=""
                style="margin-top: 22px;"></a>
            <a href="https://instagram.com/vimiu.renderstudio?r=nametag"> <img src="../assets/Ins.png" alt=""
                style="margin-top: 15px;"></a>
            <a href="https://www.pinterest.com/VimiuNews/_created/"> <img src="../assets/Pinterest.png" alt=""
                style="margin-top: 15px;"></a>
          </div>
        </div>
      </el-aside>
      <el-main>
            <div class="img-box"  style="width: 700px;height: 400px;">
               <div class="item" v-for="(e, index) in imgArr" :key="index"  :data-w="e.width"   :data-h="e.height"
                    @mousemove="mousemoveEvt(e)" @mouseout="mouseoutEvt" @click.stop="imgEvt(e)"    style="cursor: pointer;">
                    <img :src="e.thumb"   style="height: 400px;width: 700px;" />
                    <span  style="position: absolute; margin: auto; color: #fff;line-height: 400px;">{{ e.project }}</span>
                  </div>
            </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { HomeApi, InfoApi } from "@/api/a/index.js";
import "../assets/js/flex-images";
export default {
  name: 'HelloWorld',
  data() {
    return {
      imgArr: [],
      //已选中图片数据
      selectArr: [],
      infoArr: {},
      mousemoveId: "",
      checkValue: false, //chenced的默认值
      searchLabelDialog: false,
      dialogTop_one: null,
      currentImageIndex: 0, // 当前显示的图片索引
      showFullscreen: false,
      fullscreenImage: '',
      localActiveIndex: this.activeIndex,// 通过 prop 初始化一个组件内部的数据
      type: 4
    }
  },
  created() {
    HomeApi({
      kind: this.type,
    }).then((res) => {
      this.imgArr = res.data.items
    })

    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener("keyup", this.handKeyEvt, true);
  },
  updated() {
    this.$nextTick(() => {
      new flexImages({
        selector: ".flex-images",
        rowHeight: 280
      });
    });
  },
  mounted() {
    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);

    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {

    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = '8vh'
        this.dialogTop_one = '1vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = '10vh'
        this.dialogTop_one = '10vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = '15vh'
        this.dialogTop_one = '15vh'

      } else if (window.innerWidth <= 3840) {
        this.dialogTop = '20vh'
        this.dialogTop_one = '20vh'

      }
    },
    //空格打开弹窗关闭事件
    clearValues() {
      // 清空相关值
      this.infoArr = [];
      this.currentIndex = 0;
    },
    mousemoveEvt(res) {
      this.mousemoveId = res.source_id;
    },
    mouseoutEvt() {
      this.mousemoveId = "";
    },
    imgScrollEvt(e) { },
    // 获取已选中图片的source_id
    getSourceId() {
      var source_ids = this.selectArr.map(res => res.id);
      return source_ids;
    },
    exitFullscreen() {
      this.showFullscreen = false;
      this.fullscreenImage = '';
    },
    prevImage() {
      if (this.currentImageIndex === 0) {
        this.currentImageIndex = this.imgArr.length - 1; // 切换到最后一张图片
      } else {
        this.currentImageIndex--; // 切换到上一张图片
      }
      const currentImage = this.imgArr[this.currentImageIndex];
      this.getFullscreenImage(currentImage.id);
    },
    nextImage() {
      if (this.currentImageIndex === this.imgArr.length - 1) {
        this.currentImageIndex = 0; // 切换到第一张图片
      } else {
        this.currentImageIndex++; // 切换到下一张图片
      }
      const currentImage = this.imgArr[this.currentImageIndex];
      this.getFullscreenImage(currentImage.id);
    },
    getFullscreenImage(imageId) {
      InfoApi({
        id: imageId
      }).then(res => {
        this.showFullscreen = true;
        this.fullscreenImage = res.data.url;
      });
    },
     imgEvt(e) {
       window.location.href = e.url;
    },
    changeImage(offset) {
      // 改变当前显示的图片索引
      this.currentImageIndex += offset;
      if (this.currentImageIndex < 0) {
        this.currentImageIndex = this.imgArr.length - 1;
      } else if (this.currentImageIndex >= this.imgArr.length) {
        this.currentImageIndex = 0;
      }
    },

    handleMenuClick(index) {
      this.localActiveIndex = index; // 更新当前选中的菜单项的值
      // 根据菜单项的值进行路由跳转
      switch (index) {
        case '1':
          this.$router.push('/');
          break;
        case '2':
          this.$router.push('/interior');
          break;
        case '3':
          this.$router.push('/Exterior');
          break;
        case '4':
          this.$router.push('/Animation');
          break;
        case '5':
          this.$router.push('/VR');
          break;
        case '6':
          this.$router.push('/About');
          break;
        case '7':
          this.$router.push('/Contact');
          break;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../assets/js/flex-images.css");

.el-header,
.el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
}

.el-aside {
  background-color: #fff;
  color: #333;
  text-align: center;
}

/deep/.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;

}

/deep/.el-main {
  height: 100vh;
  padding: 0px !important;
}


.leftEvt {
  .img_one {
    width: 88px;
    display: block;
    margin-top: 47px;
    margin-left: 25px;
  }

  img {
    width: 22px;
    height: 22px;
  }

  .div_one {
    width: 75px;
    height: 316px;
    margin: 30px auto 0 auto;
  }

  b {
    display: block;
    height: 25px;
    text-align: left;
    font-size: 15px;
    cursor: pointer;
  }

  b:nth-of-type(2) {
    margin-top: 22px;
    color: #6f6d6d;
    font-size: 12px;
    font-weight: 400
  }

  b:nth-of-type(3) {
    color: #6f6d6d;
    font-size: 12px;
    font-weight: 400
  }

  span {
    font-size: 12px;
    color: #6f6d6d;
    cursor: pointer;
  }

  span:nth-child(4) {
    margin-left: 15px;
  }
}


/deep/ .flex-images {
  width: 100%;
  display: flex;
  flex-direction: column;
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr 1fr 1fr  1fr;
  // grid-template-rows: 1fr 1fr;
}

.img-box {
  background: #fff;
}

.img-box .item {
  position: relative;
  display: flex !important;
  justify-content: center;
  border: none;
}

.img-box .item img {
  width: 100%;
  object-fit: contain;
}

.item_one {
  position: relative;
  // display: flex !important;
  // justify-content: center;
  border: none;
}


.select {
  position: absolute;
  right: -25px;
  top: -25px;
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: transparent #409eff transparent transparent;
  transform: rotate(135deg);
  color: #fff;
}

.select1 {
  position: absolute;
  left: 10px;
  top: 9px;
  width: 36px;
  height: 24px;
  color: #fff;
  background: #dd127b;
  border-radius: 6px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
}

.el-icon-check {
  position: absolute;
  font-size: 18px;
  top: -9px;
  left: 5px;
  transform: rotate(223deg);
}

.block1 {
  position: fixed;
  right: 1%;
  top: 1%;
}



.image-container {
  position: relative;
}

.prev-button {
  position: absolute;
  left: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.prev-button:hover {
  cursor: url(""), auto;

}

.next-button {
  position: absolute;
  right: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.next-button:hover {
  cursor: url(""), auto;
}

.fullscreen {
  position: fixed;
  top: 0;
  left: 140px;
  width: calc(100% - 1%);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.fullscreen img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
}
.div_one span:hover{
  color: #333;
  font-weight: 500;
}
@media screen and (min-width: 0px) and (max-width: 1920px) {
  .fullscreen {
    width: calc(100% - 6%) !important;
  }
}

@media screen and (min-width: 1921px) and (max-width: 2560px) {
  .fullscreen {
    width: calc(100% - 6%) !important;
  }
}

@media screen and (min-width: 2561px) and (max-width:3440px) {}

@media screen and (min-width: 3441px) and (max-width: 3840px) {
  .fullscreen {
    width: calc(100% - 1%) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VR.vue